export default __webpack_public_path__ + "static/media/Reports.41baeedf.svg";